import { useState } from "react";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const formFields = [
  { name: "firstName", placeholder: "FIRST NAME" },
  { name: "lastName", placeholder: "LAST NAME" },
  { name: "email", placeholder: "EMAIL" },
  { name: "linkedin", placeholder: "Linkedin Account" },
];

function StaySection() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    linkedin: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    for (let key in formData) {
      if (!formData[key]) {
        toast.error("Please fill all fields!");
        return;
      }
    }
    if (!formData.email.includes("@")) {
      toast.error("Email must include @");
      return;
    }

    console.log(`Form submitted:\n${JSON.stringify(formData, null, 2)}`);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      linkedin: "",
    });
  };
  return (
    <section
      style={{
        paddingTop: "96px",
        paddingBottom: "96px",
      }}
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8 flex flex-col md:flex-row items-start justify-between gap-8">
        <motion.div
          className="mx-auto text-center md:text-left"
          style={{ width: "90%", maxWidth: "340px" }}
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h2
            className="font-semibold mb-2"
            style={{
              color: "var(--color-primary)",
              fontSize: "28px",
              width: "96%",
            }}
          >
            Stay In The Loop Join Our Community
          </h2>
          <p style={{ fontSize: "16px", color: "rgba(75, 75, 75, 1)" }}>
            Connect with peers and experts to shape the future of data
            management together. Leave your name and email to join.
          </p>
        </motion.div>

        <motion.form
          className="md:w-2/3 flex flex-col gap-3 w-full"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          {formFields.map((field) => (
            <input
              key={field.name}
              type={field.name === "email" ? "email" : "text"}
              name={field.name}
              placeholder={field.placeholder}
              value={formData[field.name]}
              onChange={handleChange}
              className="w-full p-3 border border-gray-500 rounded-md placeholder-gray-700"
              style={{ backgroundColor: "#D2DBEC" }}
            />
          ))}

          <Button
            content="SEND"
            className="mx-auto md:mx-0 w-full md:w-24"
            onClick={handleSubmit}
          />
        </motion.form>
      </div>
    </section>
  );
}

export default StaySection;
